<template>
    <b-card body-class="d-flex flex-column justify-content-between">
        <div v-if="!loading" class="border rounded" style="padding: 18px;">
            <h4 @click="$router.push('/ratings-and-comments')" class="text-center font-weight-bolder pointer mb-75">
                امتیاز و نظرات
            </h4>
            <div class="d-flex align-items-center justify-content-center mb-1">
                <b-img v-for="n in rate" :key="n" src="@/assets/images/icon/star.svg" alt="logo"
                    style="width: 25px; height: 25px;" />
            </div>
            <div class="mb-1">
                <h5 class="text-center">نظرات در حال بررسی</h5>
                <h4 class="text-center font-weight-bolder text-warning mb-0">
                    {{ `${dashboardData.underReviewCommentsCount} نظر` }}
                </h4>
            </div>
            <div>
                <h5 class="text-center">نظرات تایید شده</h5>
                <h4 class="text-center font-weight-bolder text-success mb-0">
                    {{ `${dashboardData.approvedCommentsCount} نظر` }}
                </h4>
            </div>
        </div>
    </b-card>
</template>

<script>
import { BCard, BButton, BRow, BCol, BImg } from 'bootstrap-vue';
export default {
    name: 'ratings',
    components: {
        BCard,
        BButton,
        BRow,
        BCol,
        BImg
    },
    props: {
        dashboardData: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            loading: true,
            rate: this.dashboardData.rate ? Math.floor(this.dashboardData.rate) : 5
        }
    },
    mounted() {
        this.loading = false
    }
}
</script>